export default "__VITE_ASSET__CIDs$7Yl__"